import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { getApiErrorMessage } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { googleComplete } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await googleComplete(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${user.full_name || user.email}!`);
        navigate("/", { replace: true, state: { user } });
      } catch (err) {
        toast.error(getApiErrorMessage(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [googleComplete, navigate]);

  return (
    <div className="smifs-hero-gradient flex min-h-dvh items-center justify-center">
      <div className="glass-card px-8 py-6 text-sm text-[var(--ink-muted)]" data-testid="auth-callback-loading">
        Signing you in with Google...
      </div>
    </div>
  );
}
